// extracted by mini-css-extract-plugin
export default {"file":"style_file__j+Otl","file_title":"style_file_title__0Sj2m","noData":"style_noData__5avUi"};